// extracted by mini-css-extract-plugin
export default {"container":"canceled_container__J1sgo","deliveryRow":"canceled_deliveryRow__EkVRA"};